module.exports = __webpack_public_path__ + "img/obs_water_refuge_down.e1bb7cea.svg";